import {
  User,
  Organization,
  useAssociateUserWithOrganizationMutation,
} from "@/graphql/types";
import { ParentQueryKey } from "../symbols";
import injectStrict from "@/utilities/injectstrict";

export default function (user: User) {
  const parentQuery = injectStrict(ParentQueryKey);

  const mutation = useAssociateUserWithOrganizationMutation({});

  function call(organization: Organization) {
    mutation.mutate(
      {
        input: {
          userId: user.id,
          organizationId: organization.id,
        },
      },
      {
        context: {
          useMultipart: true,
        },
        update: (cache) => {
          const cachedData = cache.readQuery(parentQuery);

          const updatedUsers = cachedData?.users?.nodes?.map((node) => {
            if (node?.id === user.id) {
              return {
                ...node,
                organization: organization,
              };
            }
            return node;
          });

          cache.writeQuery({
            ...parentQuery,
            data: {
              ...cachedData,
              users: {
                ...cachedData?.users,
                nodes: updatedUsers,
              },
            },
          });
        },
      }
    );
  }

  return {
    ...mutation,
    call,
  };
}
